import FilterForm from '../../../components/forms/FilterForm';
import { CanAccess, CrudFilters, HttpError } from '@refinedev/core';
import { EditButton, TextField, useTable } from '@refinedev/antd';
import { EyeOutlined } from '@ant-design/icons';
import { Form, Select, Space, Table } from 'antd';
import { ListLayout } from '../../../components/layout/layout/ListLayout';
import { TOfferCampaignAsset } from 'interfaces/offers';

interface IFilter {
  name: string;
  status: string;
}

export const OfferCampaignAssetList = () => {
  const { tableProps, searchFormProps } = useTable<
    TOfferCampaignAsset,
    HttpError,
    IFilter
  >({
    resource: 'offers/campaigns/assets',

    onSearch: params => {
      const filters: CrudFilters = [];
      const { status } = params;

      filters.push({
        field: 'filter[status]',
        operator: 'eq',
        value: status
      });

      return filters;
    }
  });

  return (
    <ListLayout title="Banners">
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="status">
          <Select placeholder="Status" className="lg:!min-w-[300px]">
            <Select.Option key="disabled">Desabilitado</Select.Option>
            <Select.Option key="expired">Expirado</Select.Option>
            <Select.Option key="active">Ativo</Select.Option>
          </Select>
        </Form.Item>
      </FilterForm>
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="alt_text"
          key="alt_text"
          title="Texto (acessibilidade)"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="status"
          key="status"
          title="Status"
          render={value => (
            <TextField
              value={
                value === 'disabled'
                  ? 'Desabilitado'
                  : value === 'expired'
                  ? 'Expirado'
                  : value === 'active'
                  ? 'Ativo'
                  : '-'
              }
            />
          )}
        />
        <Table.Column
          dataIndex="desktop_url"
          key="desktop_url"
          title="Imagem desktop"
          render={value => <TextField value={value} />}
        />
        <Table.Column<TOfferCampaignAsset>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={80}
          render={(_, record) => {
            return (
              <Space>
                <CanAccess resource="offer_campaign_assets" action="edit">
                  <EditButton
                    hideText
                    size="small"
                    recordItemId={record.id}
                    icon={<EyeOutlined />}
                  />
                </CanAccess>
              </Space>
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
